module.exports = __webpack_public_path__ + "f413036db7d23faaaf6646c2af9ca2cf.png";